import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { TimeTableActionMenuProps } from "../TimeTable.tsx";
import { AddTimeSlotAction } from "./Actions/AddTimeSlotAction.tsx";
import { TwentyFourHourAction } from "./Actions/TwentyFourHourAction.tsx";
import TranslationWrapper from "../../../old/beheer/components/TranslationWrapper/TranslationWrapper.tsx";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import EditIcon from "@mui/icons-material/Edit";

export const ExceptionsTableActionMenu = <T,>({
  onChange,
  openingHours,
  row,
  onRemove,
  onCopy,
  onEdit,
  defaultData,
}: TimeTableActionMenuProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id={"actionMenuButton"}
        aria-controls={open ? "actionMenu" : undefined}
        aria-haspopup={"true"}
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={"actionMenu"}
        aria-labelledby={"actionMenu"}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        MenuListProps={{
          "aria-labelledby": "actionMenuButton",
        }}
      >
        <MenuItem
          onClick={() => {
            onEdit();
            handleClose();
          }}
        >
          <EditIcon />
          <Typography>
            <TranslationWrapper tKey={"OpeningHoursActionsMenu.Edit"} tDefault={"Edit"} />
          </Typography>
        </MenuItem>
        <AddTimeSlotAction<T>
          defaultData={defaultData}
          openingHours={openingHours}
          onChange={onChange}
          row={row}
          handleClose={handleClose}
        />
        <MenuItem
          onClick={() => {
            onCopy();
            handleClose();
          }}
        >
          <FileCopyIcon />
          <Typography>
            <TranslationWrapper tKey={"OpeningHoursActionsMenu.Copy"} tDefault={"Copy"} />
          </Typography>
        </MenuItem>
        <TwentyFourHourAction<T>
          defaultData={defaultData}
          openingHours={openingHours}
          onChange={onChange}
          row={row}
          handleClose={handleClose}
        />
        <MenuItem
          onClick={() => {
            onRemove();
            handleClose();
          }}
        >
          <DeleteForeverIcon />
          <Typography>
            <TranslationWrapper tKey={"ExceptionsTableActionMenu.Remove"} tDefault={"Remove"} />
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
